import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [premium, setPremium] = useState(null);

  const refreshPremium = useCallback(async () => {
    try {
      const r = await api.get("/premium/status");
      setPremium(r.data);
      // Let PlayerContext refresh its ad config (free vs premium tier).
      try { window.dispatchEvent(new CustomEvent("o1:premium-changed", { detail: r.data })); } catch { /* noop */ }
      return r.data;
    } catch {
      setPremium(null);
      try { window.dispatchEvent(new CustomEvent("o1:premium-changed", { detail: null })); } catch { /* noop */ }
      return null;
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      refreshPremium();
    } catch {
      setUser(null);
      setPremium(null);
    } finally {
      setLoading(false);
    }
  }, [refreshPremium]);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setUser(null);
    setPremium(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, checkAuth, premium, refreshPremium }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
